var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_1212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4H5.5C4.39 4 3.5 4.9 3.5 6V18C3.5 19.1 4.4 20 5.5 20H8.5C9.05 20 9.5 19.55 9.5 19C9.5 18.45 9.05 18 8.5 18H5.5V8H19.5V18H16.5C15.95 18 15.5 18.45 15.5 19C15.5 19.55 15.95 20 16.5 20H19.5C20.6 20 21.5 19.1 21.5 18V6C21.5 4.9 20.61 4 19.5 4ZM12.15 10.35L9.36 13.14C9.04 13.46 9.26 14 9.71 14H11.5V19C11.5 19.55 11.95 20 12.5 20C13.05 20 13.5 19.55 13.5 19V14H15.29C15.74 14 15.96 13.46 15.64 13.15L12.85 10.36C12.66 10.16 12.34 10.16 12.15 10.35Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_1212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2b2f26cb2ae4d3e4645c54360775e410.svg";
export { ForwardRef as ReactComponent };